module.exports = __webpack_public_path__ + "static/media/14_temperance.870dfa9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/14_temperance.png
// module id = 77
// module chunks = 0